// src/tutorial/TourGuideProvider.jsx
import React from 'react';
import { TourProvider } from '@reactour/tour';

export default function TourGuideProvider({ children }) {
    return (
        <TourProvider
            steps={[]}
            disableInteraction
            scrollSmooth={false}
            styles={{
                popover: (b) => ({ ...b, zIndex: 100000, borderRadius: 12 }),
                maskWrapper: (b) => ({ ...b, zIndex: 99999 }),
                maskArea: (b) => ({ ...b, rx: 10 }),
                badge:   (b) => ({ ...b, zIndex: 100001 }),
            }}
            afterOpen={() => { document.body.style.overflow = 'hidden'; }}
            beforeClose={() => { document.body.style.overflow = ''; }}
        >
            {children}
        </TourProvider>
    );
}
